export default __webpack_public_path__ + "static/flow-transparent-logo-58ad4f9a99e75ef42bb45a07c4d7fdc4.png";